<template>
  <div class="article-bg">
    <div class="article-container">
      <button class="back-btn" @click="goBack">← 返回</button>
      <div class="article-header">
        <h1 class="article-title">{{ note.title }}</h1>
        <div class="article-meta">
          <span>{{ note.year }}-{{ note.month }}-{{ note.day }}</span>
          <span class="dot">·</span>
          <span>浏览量：{{ note.views }}</span>
          <span class="dot">·</span>
          <span>作者：{{ note.nickName }}</span>
        </div>
      </div>
      <div class="article-content" v-html="note.desc"></div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineOptions, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import moment from 'moment'
import { getArticleDetail } from '@/api/articles'
import { ElMessage } from 'element-plus'
defineOptions({ name: 'NoteDetailPage' })

const router = useRouter()
const route = useRoute()
const note = ref({
  title: '',
  year: '',
  month: '',
  day: '',
  views: '',
  desc: ''
})

async function loadDetail(){
  const id = route.params.id
  const type=route.params.type
  if(!id){
    return
  }
  console.log(id)
  console.log(type)
  const res = await getArticleDetail(id,type)
  console.log(res.data)
  if(res.data===undefined){
        ElMessage.success('无丹尼斯笔记阅读权限！')
        goBack()
    }
  if(res && (res.code === 200 || res.success)){
    console.log(res.data)
    const data = res.data || res.rows || res
    const [year, month, day] = moment(data.createdDate).format('YYYY-MM-DD').split('-')
    note.value = {
      title: data.title,
      year,
      month,
      day,
      views: data.views,
      desc: data.content || data.summary,
      nickName: data.backup2
    }
  }
}

onMounted(loadDetail)
function goBack() {
  router.back()
}
</script>

<style scoped>
.article-bg {
  min-height: 100vh;
  background: #f8fafc;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 48px 0;
}
.article-container {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 6px 32px rgba(0,0,0,0.08);
  padding: 48px 40px 40px 40px;
  min-width: 360px;
  max-width: 720px;
  width: 100%;
  position: relative;
}
.back-btn {
  position: absolute;
  left: 32px;
  top: 24px;
  background: none;
  border: none;
  color: #258aff;
  font-size: 16px;
  cursor: pointer;
  font-weight: 600;
  padding: 0;
  transition: color 0.2s;
}
.back-btn:hover {
  color: #00b8d9;
}
.article-header {
  text-align: center;
  margin-bottom: 32px;
}
.article-title {
  font-size: 2.2rem;
  font-weight: bold;
  color: #222;
  margin-bottom: 12px;
  border-bottom: 2px solid #e6e6e6;
  padding-bottom: 8px;
  display: inline-block;
}
.article-meta {
  color: #888;
  font-size: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
.article-meta .dot {
  font-size: 18px;
  color: #ccc;
}
.article-content {
  color: #333;
  font-size: 18px;
  line-height: 2.1;
  text-align: justify;
  min-height: 120px;
  word-break: break-all;
}
.article-content img {
  display: block;
  margin: 24px auto;
  max-width: 100%;
  border-radius: 8px;
}
/* 作用于 v-html 注入的图片，避免超出容器（scoped 下需使用 :deep）*/
.article-content :deep(img) {
  display: block;
  margin: 24px auto;
  max-width: 100% !important;
  height: auto !important;
  border-radius: 8px;
}
</style> 